import type { CityConfig } from "../city-template/types";

export const greenwoodConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Greenwood",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "greenwood-in",
  route: "/cities/greenwood-in",
  title: "Emergency Passport Greenwood, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Greenwood, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Greenwood, Franklin, Bargersville, Trafalgar, and all Johnson County residents. A+ BBB rated registered courier serving Indianapolis south suburbs.",
  h1: "Emergency & Expedited Passport Services in Greenwood, IN",
  heroSubtitle: "Greenwood travelers — from Johnson County business professionals heading abroad to Franklin College students studying overseas to south-suburban families planning international vacations — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 20 minutes north via I-65.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Greenwood%20Indiana%20suburban%20cityscape%20with%20Greenwood%20Park%20Mall%20area%20and%20modern%20commercial%20developments%2C%20tree%20lined%20suburban%20streets%20with%20homes%2C%20Johnson%20County%20landscape%20with%20mix%20of%20residential%20and%20business%20districts%2C%20warm%20afternoon%20sunlight%2C%20professional%20suburban%20photography%20with%20natural%20warm%20tones%2C%20classic%20Midwest%20suburban%20charm%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=greenwood-in-hero-001&orientation=landscape",
  heroImageAlt: "Greenwood Indiana suburban landscape with Johnson County commercial and residential areas",
  geoPosition: "39.6136;-86.1067",
  geoPlacename: "Greenwood, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 3 hours northwest via I-65 — about 185 miles",
  },
  nearbyCitiesZips: [
    { name: "Greenwood", zips: "46142, 46143" },
    { name: "Franklin", zips: "46131" },
    { name: "Bargersville", zips: "46106" },
    { name: "Trafalgar", zips: "46181" },
    { name: "Whiteland", zips: "46184" },
    { name: "New Whiteland", zips: "46184" },
    { name: "Southport", zips: "46227" },
    { name: "Beech Grove", zips: "46107" },
    { name: "Center Grove area", zips: "46143" },
    { name: "Johnson County rural area", zips: "46131, 46106, 46181" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — just 20 minutes from Greenwood via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Johnson County" },
    { icon: "ri-building-line", title: "South Suburban Hub", desc: "Serving Greenwood's business community, Franklin College, and Johnson County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Greenwood or Franklin" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Carmel, IN", route: "/cities/carmel" },
    { name: "Urgent passport services in Fishers, IN", route: "/cities/fishers" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Greenwood, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 3 hours via I-65. We handle the drive so Greenwood residents, Johnson County business travelers, and Franklin College students never need to navigate downtown Chicago.",
  fpcOfficeDistance: "Serving Greenwood, Franklin, Bargersville, Trafalgar, Whiteland, Southport, Beech Grove, and all of Johnson County and the south Indianapolis suburbs",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Greenwood and Johnson County. From the Greenwood Park Mall area and commercial corridors to Franklin College and the growing Bargersville community — we serve all of Johnson County and the southern Indianapolis metro area.",
  nearbyCitiesIntro: "We serve Greenwood and all nearby communities including Franklin, Bargersville, Trafalgar, Whiteland, Southport, and Beech Grove. We also serve all of Johnson County and the Center Grove area.",
  howItWorksIntro: "Most Greenwood travelers — especially Johnson County business professionals and Franklin College students — complete everything online and ship documents via overnight courier from any UPS or FedEx in Greenwood. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Greenwood is one of Indiana's fastest-growing cities with a strong business community and a thriving college in Franklin. Here are the most common passport mistakes we see from Johnson County travelers.",
  testimonialsIntro: "Greenwood travelers — from business executives to Franklin College students to Johnson County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Greenwood, IN? Here are the most common ones we hear from Johnson County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Indianapolis drive required — ship from Greenwood", "Perfect for business travel, Franklin College study abroad, and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~20 minutes each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Greenwood travelers with immediate departure needs — as fast as 24 hours. Ideal for Johnson County business professionals with last-minute international client meetings or Franklin College students with urgent study abroad deadlines.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 20-minute drive", "Business travel and college student support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Greenwood adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Johnson County professionals and families.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Greenwood address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Greenwood residents, Franklin College students, and Johnson County families.",
      bullets: ["Acceptance facility scheduling in Greenwood or Franklin", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Greenwood and Johnson County residents — whether lost during travel, misplaced at home, or stolen while preparing for a trip.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Greenwood and Johnson County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Greenwood and Johnson County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Greenwood IN", description: "Urgent passport processing for Greenwood Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Greenwood IN", description: "Fast passport renewal for Greenwood Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Greenwood IN", description: "New passport application services for Greenwood Indiana residents and Franklin College students." },
    { name: "Child Passport Greenwood IN", description: "Minor passport services for Greenwood Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Greenwood, IN — Center Grove Area",
      rating: 5,
      text: "I'm a sales director covering the Midwest and got a last-minute client meeting in Toronto with 6 days notice. My passport had expired during COVID. Fast Passport Center renewed it in 3 days and I made my meeting. Shipped from the UPS Store on Emerson Avenue. Outstanding service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Professor David A.",
      location: "Franklin, IN — Franklin College",
      rating: 5,
      text: "Research conference in Dublin with 10 days notice. My passport was valid but cutting it close on the 6-month rule. Fast Passport Center expedited everything and I had my new passport in 4 days. Made the conference with time to spare. Highly recommend for academic travelers.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Sarah & Michael R.",
      location: "Greenwood, IN — Near Greenwood Park Mall",
      rating: 5,
      text: "Family trip to Italy with two kids needing first-time passports. The Greenwood Post Office was booked solid for 3 weeks. Fast Passport Center guided us through the entire process and all four passports arrived in 5 days. We made our flight and had an amazing trip.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin T.",
      location: "Bargersville, IN",
      rating: 5,
      text: "Lost my passport somewhere between moving houses from Greenwood to Bargersville. Had a flight to Cancun in 7 days. Fast Passport Center replaced it in 48 hours. The courier service to the Indianapolis agency made all the difference. Could not be more grateful.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "greenwood-in-1",
      name: "Greenwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 N Madison Ave",
      city: "Greenwood",
      state: "IN",
      zip: "46142",
      phone: "(317) 881-0186",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Greenwood, Old Town area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Greenwood acceptance facility. Appointments required — book 2–3 weeks ahead during peak travel seasons. Convenient for Center Grove area and Franklin College students.",
      icon: "ri-mail-line",
    },
    {
      id: "greenwood-in-2",
      name: "Franklin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 E Jefferson St",
      city: "Franklin",
      state: "IN",
      zip: "46131",
      phone: "(317) 736-7711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles south of Greenwood, in downtown Franklin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility in Franklin. Often has better appointment availability than Greenwood during peak seasons. Convenient for Franklin College students and Bargersville residents.",
      icon: "ri-mail-line",
    },
    {
      id: "greenwood-in-3",
      name: "Indianapolis South Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4925 S Emerson Ave",
      city: "Indianapolis",
      state: "IN",
      zip: "46203",
      phone: "(317) 780-6565",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles north of Greenwood, on the south side of Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility on Indianapolis south side. More appointment slots available than Greenwood locations. Convenient from I-65.",
      icon: "ri-mail-line",
    },
    {
      id: "greenwood-in-4",
      name: "Johnson County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "5 E Jefferson St",
      city: "Franklin",
      state: "IN",
      zip: "46131",
      phone: "(317) 346-4440",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Downtown Franklin, Johnson County Courthouse",
      website: "https://www.co.johnson.in.us/",
      websiteLabel: "Johnson County",
      notes: "County clerk passport acceptance. Extended morning hours. Good alternative when post office appointments are full. Convenient for Franklin College students.",
      icon: "ri-government-line",
    },
    {
      id: "greenwood-in-5",
      name: "Bargersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "57 E Harriman Ave",
      city: "Bargersville",
      state: "IN",
      zip: "46106",
      phone: "(317) 422-5117",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 8 miles south of Greenwood, in Bargersville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving southern Johnson County. Good option for Bargersville and Trafalgar area residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 20-minute drive to Indianapolis via I-65", fpc: "No — ship from Greenwood, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Franklin College Study Abroad", agency: "No special support for students", fpc: "Experienced with Franklin College study abroad deadlines" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Greenwood business travelers often book international meetings on short notice — 7 to 14 days out. Routine passport processing takes 8–11 weeks, which doesn't work when your client in London or Toronto wants to meet next week. Start expedited processing as soon as travel is confirmed.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Photos from local drugstores sometimes fail State Department standards for lighting, background, or expression. Greenwood's Walgreens and CVS locations offer passport photos, but always confirm they meet the exact 2x2 inch, white background, no-glasses specification before leaving the store.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants and Franklin College students often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 can be mailed for most renewals — verify which form applies to your situation.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Franklin College Deadlines",
      description: "Franklin College study abroad programs have fixed application and departure dates. Students often wait until after acceptance to check passport status, leaving only weeks to get everything done. Check your passport as soon as you apply to the program.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Johnson County business travelers heading to Europe or Asia often discover this requirement too late — especially for trips booked on short notice.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Indianapolis Agency Accepts Walk-Ins",
      description: "Even though the Chicago Passport Agency is just 20 minutes up I-65, it does not accept walk-ins. Appointments must be booked through NPIC and are not guaranteed, especially during peak travel seasons. A courier service removes this uncertainty entirely.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Greenwood or Johnson County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS Store or FedEx in Greenwood, Franklin, or the Center Grove area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Johnson County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the short but inconvenient drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Greenwood address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Greenwood, IN?", a: "Fast Passport Center offers emergency passport processing in Greenwood, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — just 15 miles north of Greenwood." },
    { q: "Does Greenwood have its own passport agency?", a: "No — Greenwood does not have a regional passport agency. The nearest is the Chicago Passport Agency, just 15 miles north (about a 20-minute drive via I-65). Fast Passport Center's courier service means Greenwood and Johnson County residents never need to drive to Indianapolis for passport processing." },
    { q: "Can Franklin College students get expedited passports for study abroad?", a: "Yes. Franklin College students preparing for study abroad programs are among our most common clients in the Greenwood area. Study abroad acceptance often comes with tight departure deadlines — we can process expedited passports for students with confirmed travel plans." },
    { q: "What about business travelers from Greenwood's corporate offices?", a: "Greenwood and Johnson County host numerous corporate offices and distribution centers. We regularly serve business travelers who need expedited passports for international client meetings, site inspections, and conferences booked on short notice. Our processing matches business timelines, not government ones." },
    { q: "What airport do Greenwood travelers use?", a: "Indianapolis International Airport (IND) is the primary airport for Greenwood travelers, located about 25 miles northwest (approximately 30 minutes via I-65 and I-465). IND offers direct flights to Toronto, Cancun, and Paris (seasonal), plus connecting service worldwide through major hubs." },
    { q: "How much does an expedited passport cost in Greenwood, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Greenwood?", a: "Walgreens (multiple locations including 1298 N State Road 135 and 3100 Meridian Parke Dr), CVS (8820 US-31 S), and the UPS Store (multiple locations) all offer passport photo services in Greenwood. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Bargersville, Trafalgar, or Franklin residents?", a: "Absolutely. Fast Passport Center serves all of Johnson County including Bargersville, Trafalgar, Franklin, Whiteland, and the Center Grove area. Our courier service works the same way for everyone throughout the southern Indianapolis suburbs." },
  ],
  photoLocations: [
    { name: "Walgreens — Greenwood (State Road 135)", address: "1298 N State Road 135, Greenwood, IN 46142", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Greenwood (US-31)", address: "8820 US-31 S, Greenwood, IN 46227", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Greenwood (Emerson Ave)", address: "8735 S Emerson Ave, Indianapolis, IN 46237", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Franklin (King St)", address: "110 N King St, Franklin, IN 46131", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Greenwood", address: "981 S State Road 135, Greenwood, IN 46143", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient south Greenwood location.", featured: true },
    { name: "Indiana BMV — Franklin", address: "1111 N Main St, Franklin, IN 46131", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Franklin and southern Johnson County. Alternative when Greenwood BMV appointments are full. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "25 miles northwest of Greenwood via I-65 and I-465 — approximately 30 minutes",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Greenwood and Johnson County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. The main gateway for Greenwood international travelers.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International Airport",
      distance: "120 miles south of Greenwood via I-65 — approximately 2 hours",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative airport for Greenwood travelers. UPS Worldport hub with domestic and limited international connections. Good option when IND flights are limited or more expensive.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "SDF Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Johnson County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Johnson County and all Indiana counties" },
    { label: "Johnson County Clerk: Marriage Licenses", url: "https://www.co.johnson.in.us/", icon: "ri-heart-line", description: "Johnson County Clerk — marriage license records for Greenwood and Johnson County" },
    { label: "Johnson County: Divorce Decrees", url: "https://www.co.johnson.in.us/", icon: "ri-file-list-3-line", description: "Johnson County Clerk of Courts — divorce decree records for Greenwood and Johnson County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Greenwood address" },
  ],
};